
import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  ChevronUp,
  Download,
  File,
  Filter,
  PlusCircle,
  RotateCcw,
  Sliders,
  StopCircle,
  User,
} from "feather-icons-react/build/IconComponents";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import Table from "../../../core/pagination/datatable";
import { useSelector } from "react-redux";
import { getSalesByTransType } from "../../../services/SalesApiServices";
import { saveAs } from 'file-saver'; // for saving files
import * as XLSX from 'xlsx'; // for excel export
import jsPDF from 'jspdf'; // for pdf generation
import moment from "moment";

const SalesItemWiseDelivery = ({Itemwisecolumns,itemwiseData,summary,pagination}) => {
  const [searchText, setSearchText] = useState("");
  const [salesData, setSalesData] = useState([]);
  const { branch } = useSelector((state) => state.branchlist);

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  useEffect(() => {
    handlesalesData();
  }, [branch]);

  const handlesalesData = async () => {
    try {
      const response = await getSalesByTransType(branch, 1);
      setSalesData(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error(
        "Failed to fetch sales invoices",
        error?.response?.data?.Message || "Something went wrong"
      );
    }
  };

  const filteredSalesData = salesData?.filter(item => {
    const customerName = item.customerName.toLowerCase();
    return customerName.includes(searchText.toLowerCase());
  });



 

 

 

  return (
    <>
     
      <div id="sales-table">
        <Table columns={Itemwisecolumns} dataSource={itemwiseData} 
         summary={summary} pagination={pagination}/>
      </div>
      {/* {filteredSalesData?.length === 0 && <p>No sales data available.</p>} */}
    </>
  );
};
export default SalesItemWiseDelivery;